// libs
import React, { memo } from 'react';
import dayjs from 'dayjs';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// helpers
import { getCityNames, getDaysOfWeekLabels, getMealSlotsLabels, } from '@/helpers/campaign';
// widgets
import EditButton from '@/widgets/EditButton';
import SummaryTable from '@/widgets/SummaryTable';
import EllipsizeContent from '@/widgets/EllipsizeContent/EllipsizeContent';
const CITY_ELLIPSIZE_COUNT = 3;
const Preferences = ({ className, cityOptions, startDate, endDate, mealSlots, daysOfWeek, cityIds, setActiveStep, }) => {
    const handleEditClick = () => {
        // Index 1 is for Preference screen
        setActiveStep(1);
    };
    const renderCities = (city, index) => {
        const color = index > CITY_ELLIPSIZE_COUNT - 1
            ? DlsColorTokens.text_inverse_Highest_Emphasis
            : DlsColorTokens.text_Highest_Emphasis;
        const variant = index > CITY_ELLIPSIZE_COUNT - 1
            ? DlsFontVariants.body_B2_Med
            : DlsFontVariants.body_B1_Bold;
        const appendComma = index !== cityOptions.length - 1 &&
            index !== CITY_ELLIPSIZE_COUNT - 1;
        return (React.createElement(Text, { key: index, variant: variant, color: color },
            city,
            appendComma && ', '));
    };
    return (React.createElement(SummaryTable.Table, { className: className },
        React.createElement(SummaryTable.Caption, null,
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Preferences"),
            React.createElement(EditButton, { label: "Edit", onClick: handleEditClick })),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Date range")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis },
                    dayjs(startDate).format('MMMM D, YYYY'),
                    " to",
                    ' ',
                    dayjs(endDate).format('MMMM D, YYYY')))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Days of the week")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, getDaysOfWeekLabels(daysOfWeek).join(', ')))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Place")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(EllipsizeContent, { renderFunction: renderCities, options: getCityNames(cityIds, cityOptions) }))),
        React.createElement(SummaryTable.Row, { widths: [40, 60] },
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Meal Slot")),
            React.createElement(SummaryTable.Cell, null,
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, getMealSlotsLabels(mealSlots).join(', '))))));
};
export default memo(Preferences);
